<template>
  <el-dialog
    title="Detalles de Interaccion"
    ref="drawerInteractionForm"
    :visible.sync="showDialogVisibleInteraction"
    width="50%"
    :before-close="handleClose"
    :append-to-body="appendToBoddy"
  >
    <el-form
      label-width="150px"
      class="demo-ruleForm"
      label-position="left"
      ref="detailInteractionDialog"
    >
      <el-form-item label="Objetivo" prop="Subject">
        <el-input v-model="Subject" disabled></el-input>
      </el-form-item>

      <el-row>
        <el-col>
          <h3>Descripción de la interacción</h3>
          <el-form-item label-width="0" prop="Description">
            <quill-editor
              disabled
              ref="myQuillEditor"
              v-model="Description"
              style="height: auto; margin-bottom: 10px"
            ></quill-editor>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  name: "DialogInteractionDetails",
  props: {
    Description: {
      type: String
    },
    Subject: {
      type: String
    }
  },
  components: {
    quillEditor
  },
  data() {
    return {
      appendToBoddy: true,
      contactByCust: "",
      showDialogVisibleInteraction: false,
      clientCode: "",
      companyId: this.$store.state.user.user.CompanySelected,
      isProspect: true
    };
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      //this.showDialogVisibleInteraction = false;
    },
    handleClose(done) {
      this.$refs["detailInteractionDialog"].resetFields();
      done();
    },
    show(clientCode, isProspect = false) {
      this.isProspect = isProspect;
      this.clientCode = clientCode;
      this.showDialogVisibleInteraction = true;
    }
  }
};
</script>
